<template>
	<transition name="fade">
		<div v-if="!isMiniSpinner" class="spinnerContainer">
			<div class="spinner">
				<div class="bar1"></div>
				<div class="bar2"></div>
				<div class="bar3"></div>
				<div class="bar4"></div>
				<div class="bar5"></div>
			</div>
		</div>
		<div v-else-if="isMiniSpinner && !showNoData" class="spinnerLoading">
			<span>Cargando Datos</span>
			<div class="bar1"></div>
			<div class="bar2"></div>
			<div class="bar3"></div>
			<div class="bar4"></div>
			<div class="bar5"></div>
		</div>
		<div v-else-if="isMiniSpinner && showNoData" class="spinnerLoading">
			<span>No hay datos para esta vista.</span>
		</div>
	 </transition>
</template>
<script>
export default {
	props: ['height', 'isMiniSpinner'],
	data () {
		return {
			showNoData: false
		};
	},
	mounted () {
		setTimeout(() => {
			this.showNoData = true;
		}, 2500);
	}
};
</script>

<style lang="scss" scoped>
@import "../../scss/global.scss";
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s
}
.fade-enter, .fade-leave-to {
  opacity: 0
}

.spinner {
	margin: 5rem auto;
	width: auto;
	height: 4rem;
	text-align: center;
	font-size: $tinySize;
	position: absolute;
	top: 35%;
	left: calc(50% - 5rem);
	&Container {
		background-color: rgba(255, 255, 255, 0.8);
		display: flex;
		justify-content: center;
		align-items: center;
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 200;
	}
	& div {
		background-color: $ascGreen;
		border-radius: 1rem;
		height: 100%;
		width: 0.7rem;
		display: inline-block;
		animation: sk-stretchdelay 1.2s infinite ease-in-out;
	}
	& .bar2 {
		animation-delay: -1.1s;
		}
		& .bar3 {
			animation-delay: -1.0s;
			}
			& .bar4 {
				animation-delay: -0.9s;
				}
				& .bar5 {
					animation-delay: -0.8s;
					}
					&Loading {
						margin: 5rem auto;
						width: auto;
						height: 2rem;
						text-align: center;
						font-size: $tinySize;
						position: relative;
						& span {
							display: flex;
							font-size: $bigTitle;
							font-weight: 700;
						}
						& div {
							background-color: $accentBlue;
							border-radius: 2rem;
							height: 100%;
							width: 0.7rem;
							display: inline-block;
							animation: sk-stretchdelay 1.1s infinite ease-in-out;
							}
							& .bar2 {
								animation-delay: -1.1s;
								}
								& .bar3 {
									animation-delay: -1.0s;
									}
									& .bar4 {
										animation-delay: -0.9s;
										}
										& .bar5 {
											animation-delay: -0.8s;
											}
					}
		}
@keyframes sk-stretchdelay {
	0%,
	40%,
	100% {
		transform: scaleY(0.4);
	}
	20% {
		transform: scaleY(1.0);
	}
}
</style>



// WEBPACK FOOTER //
// src/components/ui/Spinner.vue